import { createContext } from 'react';

// Utils
import { Observer } from '@shopee-user/intersection-observer';

// Types
import {
  TrackingInfo,
  ImpressionTrackingInfo,
  InitBITrackerParams,
} from '../types';

interface TrackingInterface {
  initTracker: (params: InitBITrackerParams) => void;
  sendTrackingEvent: (info: TrackingInfo<unknown>) => void;
  sendImpressionEvent: <T>(info: ImpressionTrackingInfo<T>) => void;
  trackingObserver: Observer | null;
}

export const TrackingContext = createContext<TrackingInterface>({
  initTracker: () => undefined,
  sendTrackingEvent: () => undefined,
  sendImpressionEvent: () => undefined,
  trackingObserver: null,
});
